<template>
    <div style="width:100%;heigh:100%;">
        <div class="table_searchbar">
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="">
                    <el-input size="small" v-model="searchForm.deviceId" maxlength="16" placeholder="DeviceID"></el-input>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="">
                        <el-input size="small" v-model="searchForm.dtuId" maxlength="16" placeholder="DTUID"></el-input>
                    </div>
                </el-col>
                <el-col :span="6" :offset="6">
                    <div style="text-align:right">
                        <el-button type="primary" @click="search()">查询</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="dtuId" label="DTUID"  ></el-table-column>
            <el-table-column prop="deviceId" label="DeviceID"  ></el-table-column>
            <el-table-column prop="time" :formatter='parseTime' label="时间" width="160"></el-table-column>
            <el-table-column label="Payload"  >
                <template slot-scope="scope">
                    <el-button @click="showPayload(scope.row)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top:10px;text-align:right" v-if="tableData.length > 0">
            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange">
            </el-pagination>
        </div>
        <el-dialog title="查看Payload" :visible.sync="payloadDialogVisible" width="80%" center>
            <el-table :data="payload" stripe style="width: 100%">
                <el-table-column prop="DevID" label="设备"  ></el-table-column>
                <el-table-column prop="TagName" label="数据项"  ></el-table-column>
                <el-table-column prop="TagValue" label="值" >
                    <template slot-scope="scope">
                        <el-input size="small" maxlength="16" v-model="payload[scope.$index].TagValue" :disabled="true"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'dataCollection',
	data () {
        return {
            searchForm:{
                deviceId:'',
                dtuId:'',
            },
            tableData:[],
            payloadDialogVisible:false,
            tableCurrentPage:1,
            payload:[],
            tableTotalPage:100
        }
    },
    mounted:function(){
        this.initTable();
    },
    methods:{
        search:function(){
            this.$RequestUtil.get({
				url: '/api/dataCollection/listData',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    deviceId:this.searchForm.deviceId,
                    dtuId:this.searchForm.dtuId
                },
                success: (res) => {
                    if(res.msg == "success"){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        
                    }
                }
            });
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        parseTime:function(val){
            return new Date(val.time).toLocaleString();
        },
        showPayload:function(rowData){
            this.payload = JSON.parse(rowData.payload);
            for(var i = 0;i<this.payload.length;i++){
                if(this.payload[i].TagType == "Bool" ){
                    if(this.payload[i].TagValue == false){
                        this.payload[i].TagValue = "false";
                    }else{
                        this.payload[i].TagValue = "true";
                    }
                }
                
            }
            this.payloadDialogVisible = true;
        }
    }
}
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}
.bg-purple {
    background: #d3dce6;
}

.table_searchbar{
    width:100%;
    height:100px;
    margin-top: 10px;
    margin-bottom: 20px;
}
.el-upload--picture-card{
    width:40px;
    height:40px;
}
</style>



// WEBPACK FOOTER //
// src/views/DataCollection.vue